<template>
  <div>
    <v-card color="background darken-1" flat class="mb-0">
      <v-app-bar flat color="background darken-1">
        <!--         <v-app-bar-nav-icon ></v-app-bar-nav-icon> -->

        <v-toolbar-title v-bind:class="moveTitleClassObject">
          Infimas Cuantías / Solicitudes de Proformas
        </v-toolbar-title>

        <v-spacer></v-spacer>

        <v-btn text dark mediun color="secondary" @click="loadData()">
          <v-icon dark>mdi-refresh</v-icon>
          Actualizar
        </v-btn>
        <excell
          :items="items"
          :headers="xlsxHeaders"
          :fieldValues="xlsxFields"
        ></excell>
      </v-app-bar>

      <!--     <v-card-title> </v-card-title>  -->

      <v-card-text class="py-0 mb-0">
        <!--         <v-alert
          icon="mdi-eye-outline"
          prominent
          border="left"
          type="primary"
          transition="fade-transition"
        >
          <v-row align="center">
            <v-col class="grow">
              <strong
                ><v-chip outlined style="border-width:4px">2022-09-26</v-chip>
                NUEVO MODO DE VISUALIZACIÓN:</strong
              >
              <br />
              Ahora el modo de vizualización predeterminado es "Por procesos".
              Esto significa que los items se agrupan para ofrecerte una lectura
              mas rápida de necesidades de ínfimas cuantías y solicitudes de
              cotización al mismo tiempo que reduce la fatiga ocular. Además, la
              cantidad de registros que se muestran por página ahora se
              establece en 25 en vez de 10.
            </v-col>
          </v-row>
        </v-alert> -->

        <v-row class="px-4 pb-2">
          <v-radio-group v-model="viewMode" row>
            <template v-slot:label>
              <strong>Modo de vizualización</strong></template
            >
            <v-radio label="Por procesos" value="group"></v-radio>
            <v-radio label="Por items" value="item"></v-radio>
          </v-radio-group>
        </v-row>
      </v-card-text>

      <v-card-actions class="py-0">
        <v-tabs
          align-with-title
          background-color="background darken-1"
          v-model="tab"
          slider-color="transparent"
          active-class="background base"
        >
          <v-tab href="#tab-1">
            <v-badge
              inline
              :content="viewMode == 'item' ? items.length : itemsGroup.length"
              :value="viewMode == 'item' ? items.length : itemsGroup.length"
              color="primary"
              transition="scale-transition"
            >
              Mis Cpc´s
            </v-badge>
          </v-tab>

          <v-tab href="#tab-2">
            <v-badge
              inline
              :content="
                viewMode == 'item' ? otrosItems.length : otrosItemsGroup.length
              "
              :value="
                viewMode == 'item' ? otrosItems.length : otrosItemsGroup.length
              "
              color="primary"
              transition="scale-transition"
            >
              Otros Cpc´s
            </v-badge>
          </v-tab>
          <v-spacer></v-spacer>
          <v-tab href="#tab-3">
            <v-chip
              class="mr-1"
              color="cyan"
              pill
              text-color="white"
              small
              transition="scale-transition"
            >
              NUEVO
              <v-icon rigth small>
                mdi-arrow-right
              </v-icon>
            </v-chip>
            <v-badge
              inline
              :content="favoritos.length"
              :value="favoritos.length"
              color="primary"
              transition="scale-transition"
            >
              <v-icon left>
                mdi-timer-star-outline
              </v-icon>

              Mis favoritos
            </v-badge>
          </v-tab>
        </v-tabs>
      </v-card-actions>
    </v-card>

    <v-container fluid grid-list-lg>
      <!--    {{ snapshots.length }}
      <v-btn @click="restoreSnapShot">RESTAURAR SNAPSHOT</v-btn> -->

      <!--       <v-row>
        <v-col>
          <v-alert
            icon="mdi-eye-outline"
            prominent
            border="left"
            type="primary"
            transition="fade-transition"
          >
            <v-row align="center">
              <v-col class="grow">
                <strong
                  ><v-chip outlined style="border-width:4px">2022-09-26</v-chip>
                  NUEVO MODO DE VISUALIZACIÓN:</strong
                >
                <br />
                Ahora el modo de vizualización predeterminado es "Por procesos".
                Esto significa que los items se agrupan para ofrecerte una
                lectura mas rápida de necesidades de ínfimas cuantías y
                solicitudes de cotización al mismo tiempo que reduce la fatiga
                ocular. Además, la cantidad de registros que se muestran por
                página ahora se establece en 25 en vez de 10.

              </v-col>
            </v-row>
            <v-row class="ma-0 px-2">
              <v-radio-group v-model="viewMode" row>
                <template v-slot:label>
                  <strong>Modo de vizualización</strong></template
                >
                <v-radio label="Por procesos" value="group"></v-radio>
                <v-radio label="Por items" value="item"></v-radio>
              </v-radio-group>
            </v-row>
          </v-alert>
        </v-col>
      </v-row> -->

      <!--  <v-row>
        <v-col>
          <v-alert
            icon="mdi-lightbulb-on-outline"
            prominent
            border="left"
            type="success"
            transition="fade-transition"
          >
            <v-row align="center">
              <v-col class="grow">
                <strong>[2022-09-05] NUEVA FUNCIÓN:</strong>
                <br />
                Con el objetivo de mejorar la productividad y la experiencia en
                la búsqueda y exploración de Necesidades de Contratación y
                Solicitudes de Proformas ahora puedes etiquetar los procesos
                como "Revisado". Esto le ayudará a evitar que vuelvas a a
                revisar un proceso que ya fue revisado anteriormente, lo que te
                permite reducir la sobrecarga visual y a centrarte en las nuevas
                oportunidades de negocios.
                <br />
                <strong
                  >Las referencias a sus procesos etiquetados solo se almacenan
                  de forma local y no se sincronizan con otros equipos o
                  usuarios.</strong
                >
              </v-col>
            </v-row>
          </v-alert>
        </v-col>
      </v-row> -->

      <v-tabs-items v-model="tab">
        <v-tab-item value="tab-1">
          <!-- <v-row>
            <v-col no-gutters>
              <resume :isLoading="loading" :agg="agg"></resume>
            </v-col>
          </v-row> -->

          <!--           <v-row>
            <v-col>
              <v-alert
                icon="mdi-bullhorn-outline"
                prominent
                v-model="entendido"
                border="left"
                type="warning"
                transition="fade-transition"
              >
                <v-row align="center">
                  <v-col class="grow">
                    <strong>-</strong> Por el momento la información se
                    actualiza 2 veces al día, por la mañana entre las 9:00 y
                    10:00 am y por las tardes de 14:00 a 15:00. Nuestro objetivo
                    a corto plazo son actualizaciones cada hora
                    <br />
                    <strong>-</strong> Solo se muestran infimas cuantias
                    abiertas, es decir, aquellas cuyo plazo de entrega de
                    propuestas se encontraban vigentes hasta antes de la última
                    actualización de los datos
                  </v-col>
                  <v-col class="shrink">
                    <v-btn color="secondary" @click="entendido = !entendido"
                      >ENTENDIDO</v-btn
                    >
                  </v-col>
                </v-row>
              </v-alert>
            </v-col>
          </v-row> -->

          <!--           <v-row>
            <v-col>
              <v-alert
                v-model="showMoreItems"
                icon="mdi-lightbulb-outline"
                prominent
                border="left"
                text
                color="primary"
                transition="scale-transition"
              >
                <v-row align="center">
                  <v-col class="grow">
                    Se han encontrado más resultados que coinciden con su
                    criterio de búsqueda en "Descripción de la compra" en otros
                    códigos CPC´s que no constan en su Registro Único de
                    Proveedor (RUP).</v-col
                  >
                  <v-col class="shrink">
                    <v-dialog
                      v-model="dialog"
                      fullscreen
                      hide-overlay
                      transition="dialog-bottom-transition"
                    >
                      <template v-slot:activator="{ on }">
                        <v-btn color="secondary" v-on="on">VER ITEMS</v-btn>
                      </template>
                      <v-card>
                        <v-toolbar dark color="primary">
                          <v-btn icon dark @click="dialog = false">
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                          <v-toolbar-title>Otros Items</v-toolbar-title>
                          <div class="flex-grow-1"></div>
                          <v-toolbar-items>
                            <v-btn dark text @click="dialog = false"
                              >Cerrar</v-btn
                            >
                          </v-toolbar-items>
                        </v-toolbar>
                        <resume
                          :isLoading="loading"
                          :agg="aggOtros"
                          class="mt-2"
                        ></resume>
                        <v-row>
                          <v-col>
                            <infimas-table
                              :items="otrosItems"
                              :loading="loading"
                            />
                          </v-col>
                        </v-row>
                      </v-card>
                    </v-dialog>
                  </v-col>
                </v-row>
              </v-alert>
            </v-col>
          </v-row> -->

          <v-row>
            <v-col>
              <infimas-table
                :viewMode="viewMode"
                :items="viewMode == 'group' ? itemsGroup : items"
                :loading="loading"
                @fastFilterAdded="takeSnapshot"
              />

              <v-alert
                v-if="totalItems > 1000 && items.length != totalItems"
                class="mt-4"
                icon="mdi-lightbulb-outline"
                prominent
                border="left"
                text
                color="primary"
                transition="fade-transition"
              >
                <v-row align="center">
                  <v-col class="grow">
                    De forma predeterminada, las búsquedas devuelven los 1.000
                    primeros resultados de la búsqueda. Si desea navegar a
                    través de un conjunto de datos más grande puede dar clic en
                    <strong>CARGAR MÁS DATOS</strong> hasta alcanzar el valor
                    establecido en Items Ejecutados, pero tenga en cuenta que
                    esta operación puede aumentar significativamente el uso de
                    la memoria y la CPU, lo que resulta en un rendimiento
                    degradado.
                  </v-col>
                  <v-col class="shrink">
                    <v-btn
                      block
                      v-on:click="loadMore()"
                      color="secondary"
                      :loading="loadingMoreBtn"
                    >
                      CARGAR MÁS DATOS
                      <template v-slot:loader>
                        <v-progress-circular
                          :size="18"
                          :width="2"
                          indeterminate
                          class="mr-1"
                        ></v-progress-circular>
                        <span>{{ $Amplify.I18n.get("Wait...") }}</span>
                      </template>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-alert>
            </v-col>
          </v-row>
        </v-tab-item>

        <v-tab-item value="tab-2">
          <!--  <v-row>
            <v-col no-gutters>
              <resume :isLoading="loading" :agg="aggOtros"></resume>
            </v-col>
          </v-row> -->

          <!--  <v-row>
            <v-col>
              <v-alert
                icon="mdi-bullhorn-outline"
                prominent
                v-model="entendido"
                border="left"
                type="warning"
                transition="fade-transition"
              >
                <v-row align="center">
                  <v-col class="grow">
                    <strong>-</strong> Por el momento la información se
                    actualiza 2 veces al día, por la mañana entre las 9:00 y
                    10:00 am y por las tardes de 14:00 a 15:00. Nuestro objetivo
                    a corto plazo son actualizaciones cada hora
                    <br />
                    <strong>-</strong> Solo se muestran infimas cuantias
                    abiertas, es decir, aquellas cuyo plazo de entrega de
                    propuestas se encontraban vigentes hasta antes de la última
                    actualización de los datos
                  </v-col>
                  <v-col class="shrink">
                    <v-btn color="secondary" @click="entendido = !entendido"
                      >ENTENDIDO</v-btn
                    >
                  </v-col>
                </v-row>
              </v-alert>
            </v-col>
          </v-row>
 -->
          <!--           <v-row>
            <v-col>
              <v-alert
                v-model="showMoreItems"
                icon="mdi-lightbulb-outline"
                prominent
                border="left"
                text
                color="primary"
                transition="scale-transition"
              >
                <v-row align="center">
                  <v-col class="grow">
                    Se han encontrado más resultados que coinciden con su
                    criterio de búsqueda en "Descripción de la compra" en otros
                    códigos CPC´s que no constan en su Registro Único de
                    Proveedor (RUP).</v-col
                  >
                  <v-col class="shrink">
                    <v-dialog
                      v-model="dialog"
                      fullscreen
                      hide-overlay
                      transition="dialog-bottom-transition"
                    >
                      <template v-slot:activator="{ on }">
                        <v-btn color="secondary" v-on="on">VER ITEMS</v-btn>
                      </template>
                      <v-card>
                        <v-toolbar dark color="primary">
                          <v-btn icon dark @click="dialog = false">
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                          <v-toolbar-title>Otros Items</v-toolbar-title>
                          <div class="flex-grow-1"></div>
                          <v-toolbar-items>
                            <v-btn dark text @click="dialog = false"
                              >Cerrar</v-btn
                            >
                          </v-toolbar-items>
                        </v-toolbar>
                        <resume
                          :isLoading="loading"
                          :agg="aggOtros"
                          class="mt-2"
                        ></resume>
                        <v-row>
                          <v-col>
                            <infimas-table
                              :items="otrosItems"
                              :loading="loading"
                            />
                          </v-col>
                        </v-row>
                      </v-card>
                    </v-dialog>
                  </v-col>
                </v-row>
              </v-alert>
            </v-col>
          </v-row> -->

          <v-row>
            <v-col>
              <infimas-table
                :viewMode="viewMode"
                :items="viewMode == 'group' ? otrosItemsGroup : otrosItems"
                :loading="loading"
                @fastFilterAdded="takeSnapshot"
              />
            </v-col>
          </v-row>
        </v-tab-item>

        <v-tab-item value="tab-3">
          <v-alert
            icon="mdi-timer-star-outline"
            prominent
            border="left"
            type="primary"
            transition="fade-transition"
          >
            <v-row align="center">
              <v-col class="grow">
                <strong
                  ><v-chip outlined style="border-width:4px">2022-10-05</v-chip>
                  NUEVO PANEL DE SEGUIMIENTO DE FAVORITOS:</strong
                >
                <br />
                Aquí se pueden visualizar todo los procesos etiquetados como
                "Favorito" ordenados según la fecha límite entrega de proformas.
                Si desea eliminar un proceso de esta vista solo debe eliminar o
                cambiar la etiqueta.
              </v-col>
            </v-row>
          </v-alert>
          <v-row>
            <v-col>
              <infimas-table-group
                :items="favoritos"
                :loading="loading"
                @fastFilterAdded="takeSnapshot"
              />
            </v-col>
          </v-row>
        </v-tab-item>
      </v-tabs-items>

      <!--       <v-row>
        <v-col>
          <span
            class="headline font-weight-regular"
            v-bind:class="moveTitleClassObject"
          >
            Dashboard
            <v-icon>mdi-chevron-double-right</v-icon>
            Items en Transito
          </span></v-col
        >
        <v-col md="auto">
          <v-btn text dark mediun color="secondary" @click="loadData()">
            <v-icon dark>mdi-refresh</v-icon>
            Actualizar
          </v-btn>
          <excell
            :items="items"
            :headers="xlsxHeaders"
            :fieldValues="xlsxFields"
          ></excell>
        </v-col>
      </v-row> -->

      <!--  <v-row no-gutters>
        <v-col>
          <v-alert
            dense
            icon="mdi-information-outline"
            border="left"
            class="py-0"
          >
            Esta vista contiene los items que se encuentran publicados en el
            portal de compras públicas que tiene cronograma vigente o que aún no
            han sido adjudicados. Este es el mejor lugar para encontrar
            oportunidades de negocios en el sector público
          </v-alert>
        </v-col>
      </v-row> -->

      <!--       <v-row no-gutters>
        <v-col>
          <v-tabs v-model="tab" grow>
            <v-tab href="#tab-1">
              <v-badge
                inline
                :content="items.length"
                :value="items.length"
                color="primary"
              >
                Mis Cpc´s
              </v-badge>
            </v-tab>

            <v-tab href="#tab-2">
              <v-badge
                inline
                :content="otrosItems.length"
                :value="otrosItems.length"
                color="primary"
              >
                Otros Cpc´s
              </v-badge>
            </v-tab>

            <v-tab-item value="tab-1"> </v-tab-item>

            <v-tab-item value="tab-2"> </v-tab-item>
          </v-tabs>
        </v-col>
      </v-row> -->
    </v-container>
  </div>
</template>

<script>
import { AmplifyEventBus } from "aws-amplify-vue";
import { groupBy } from "lodash";
import { map } from "lodash";
import { mapGetters, mapActions } from "vuex";
import { postDashboard } from "@/api/private/dashboard";
import { getSuscripcion } from "@/api/private/suscripciones";
import Excell from "@/components/Excell";
import InfimasTable from "./components/InfimasTable";
import InfimasTableGroup from "./components/InfimasTableGroup";
//import Resume from "@/components/Resume";

export default {
  name: "Ejecutados",
  components: {
    Excell,
    //Resume,
    InfimasTable,
    InfimasTableGroup,
  },
  data() {
    return {
      entendido: true,
      tab: null,
      viewMode: "group",
      snackbar: false,
      snackbarText: "",
      loading: false,
      loadingMoreBtn: false,
      from: 0,
      agg: [],
      aggOtros: [],
      items: [],
      itemsGroup: [],
      otrosItems: [],
      otrosItemsGroup: [],
      favoritos: [],
      totalItems: 0,
      dialog: false,
      xlsxHeaders: [
        "AÑO",
        "CODIGO PROCESO",
        "FECHA PUBLICACIÓN",
        "FECHA LÍMITE ENTREGA PROFORMAS",
        "CONTRATANTE",
        "OBJETO DEL PROCESO",
        "DESCRIPCIÓN",
        "CPC NIVEL 5",
        "CPC NIVEL 9",
        "PROVINCIA",
        "CANTON",
        "CANTIDAD",
        "MEDIDA",
        "URL",
      ],
      xlsxFields: [
        "ano",
        "codigo_proceso",
        "fecha_publicacion",
        "fecha_limite_propuesta",
        "nombre_entidad",
        "objeto_proceso",
        "descripcion",
        "descripcion_cpc",
        "descripcion_cpc_full",
        "provincia_entidad",
        "canton_entidad",
        "pac_cantidad",
        "pac_medida",
        "url",
      ],
      logger: {},
    };
  },
  computed: {
    ...mapGetters(["filters", "snapshots"]),
    drawer() {
      return !this.$store.getters.dashboardDrawer;
    },
    showMoreItems() {
      return this.otrosItems.length > 0 && !this.loading ? true : false;
    },

    moveTitleClassObject: function() {
      return {
        "ml-12": !this.$store.getters.dashboardDrawer,
      };
    },
  },
  watch: {
    filters: {
      deep: true,
      handler: function() {
        this.loadData();
      },
    },
  },
  methods: {
    ...mapActions(["addSnapshotAction"]),
    takeSnapshot: function() {
      console.log("Snapshot created...");
      this.addSnapshotAction({ items: this.items, filters: this.filters });
    },
    group: function(items) {
      return map(
        groupBy(items, (item) => {
          return item.codigo_proceso;
        }),
        (value, key) => ({
          codigo_proceso: key,
          ...value[0],
          items: value,
        })
      );
    },
    restoreSnapShot: function() {
      this.items = this.snapshots[0].items;
    },
    elasticResultPreprocessor: function(body) {
      return body.hits.hits.map((item) =>
        Object.assign({}, item._source, { highlight: item.highlight })
      );
    },
    loadMore: async function() {
      this.from = this.from + 1000;
      this.loadingMoreBtn = true;
      await this.loadData(this.from);
      this.loadingMoreBtn = false;
    },
    loadFavoritos: async function() {
      try {
        let { data } = await getSuscripcion();
        this.favoritos = this.elasticResultPreprocessor(data.favoritos);
      } catch (e) {
        console.log(e);
      }
    },
    loadData: async function(from = 0) {
      if (!this.loadingMoreBtn) {
        this.items = [];
        this.otrosItems = [];
        this.from = 0;
        this.totalItems = 0;
      }
      this.loading = true;
      try {
        let { agg, aggOtros, items, otrosItems } = await postDashboard(from);
        this.agg = agg;
        this.aggOtros = aggOtros ? aggOtros : [];
        this.totalItems = agg && agg[0] ? agg[0].doc_count : 0;
        if (!this.loadingMoreBtn) {
          //console.log("this.items");
          this.items = this.elasticResultPreprocessor(items);
          //console.log(this.items);
          //console.log("this.itemsGroup");
          this.itemsGroup = this.group(this.items);
          //console.log(this.itemsGroup);

          this.otrosItems =
            otrosItems && otrosItems.hits
              ? this.elasticResultPreprocessor(otrosItems)
              : [];

          this.otrosItemsGroup = this.group(this.otrosItems);
        } else {
          this.items = [
            ...this.items,
            ...this.elasticResultPreprocessor(items),
          ];
          this.itemsGroup = this.group(this.items);
        }

        this.loadFavoritos();
      } catch (e) {
        console.log(e);
      } finally {
        this.loading = false;
      }
    },
  },
  mounted() {
    this.loadData();
    this.logger = new this.$Amplify.Logger(this.$options.name);
  },
  beforeCreate: function() {
    AmplifyEventBus.$on("load-favoritos", () => {
      this.loadFavoritos();
    });
  },
  beforeDestroy: function() {
    AmplifyEventBus.$off("load-favoritos");
  },
};
</script>
